import "./Landing.css";
import Intro from "./sections/Intro/Intro";
import AboutUs from "./sections/About/AboutUs";
import AppUse from "./sections/AppUse/AppUse";
import WebSection from "./sections/WebSection/WebSection";
import Footer from "./sections/Footer/Footer";
import Advertisement from "./sections/Advertisement/Advertisement";
import PricingCards from "./sections/Pricing/PricingCards";

const LandingPage = () => {
  return (
    <div>
      <Intro />
      <AboutUs />
      <AppUse />
      <Advertisement />
      <PricingCards />
      <Footer />
    </div>
  );
};

export default LandingPage;
